import { commentApi as api } from './commentApi';
export const addTagTypes = ['Comments'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getComments: build.query<GetCommentsApiResponse, GetCommentsApiArg>({
        query: queryArg => ({
          url: `/comments`,
          params: { assetId: queryArg.assetId }
        }),
        providesTags: ['Comments']
      }),
      addComments: build.mutation<AddCommentsApiResponse, AddCommentsApiArg>({
        query: queryArg => ({
          url: `/comments`,
          method: 'POST',
          body: queryArg.createComments
        }),
        invalidatesTags: ['Comments']
      }),
      updateComments: build.mutation<
        UpdateCommentsApiResponse,
        UpdateCommentsApiArg
      >({
        query: queryArg => ({
          url: `/comments/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateComments
        }),
        invalidatesTags: ['Comments']
      }),
      deleteComments: build.mutation<
        DeleteCommentsApiResponse,
        DeleteCommentsApiArg
      >({
        query: queryArg => ({
          url: `/comments/${queryArg.id}`,
          method: 'DELETE',
          params: { delete: queryArg['delete'] }
        }),
        invalidatesTags: ['Comments']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetCommentsApiResponse = /** status 200 Comments found. */ {
  ok?: boolean;
  data?: Comments;
  message?: string;
};
export type GetCommentsApiArg = {
  /** Asset ID to filter comments */
  assetId: string;
};
export type AddCommentsApiResponse =
  /** status 201 Comments has been created successfully. */ {
    ok?: boolean;
    data?: Comments;
    message?: string;
  };
export type AddCommentsApiArg = {
  /** Comments that needs to be added to the application */
  createComments: CreateComments;
};
export type UpdateCommentsApiResponse =
  /** status 200 The Comments's details has been updated successfully */ {
    ok?: boolean;
    data?: Comments;
    message?: string;
  };
export type UpdateCommentsApiArg = {
  /** ID of the Comments to update */
  id: string;
  /** Comments that needs to be added to the application */
  updateComments: UpdateComments;
};
export type DeleteCommentsApiResponse =
  /** status 200 The Comments's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteCommentsApiArg = {
  /** ID of the Comments to delete */
  id: string;
  /** flag to hard delete */
  delete?: string;
};
export type Comments = {
  count?: number;
  rows?: {
    id: string;
    userId: string;
    assetId: string;
    comment: string;
    name: string;
    profileImage: string;
    commentLikesCount: number;
    createdAt: string;
    updatedAt: string;
    commentLikes?: {
      id: string;
      userId: string;
    }[];
  }[];
};
export type CreateComments = {
  userId: string;
  assetId: string;
  comment: string;
};
export type UpdateComments = {
  comment: string;
};
export const {
  useGetCommentsQuery,
  useAddCommentsMutation,
  useUpdateCommentsMutation,
  useDeleteCommentsMutation
} = injectedRtkApi;
